import React from 'react';
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  useTheme,
  Paper,
  StepButton,
} from '@mui/material';
import { steps } from '../constants/steps';
import { useBaseStepperContext } from '../../shared/contexts/BaseStepperContext';
import { StepperFooter } from '../../shared/components/StepperFooter';
import { stepperStyles } from '../../shared/styles';

export const DesktopStepper: React.FC = () => {
  const stepperContext = useBaseStepperContext();
  const { activeStep, setActiveStep } = stepperContext;
  const theme = useTheme();

  return (
    <Box sx={stepperStyles.stepperContainer}>
      {/* Fixed stepper navigation */}
      <Paper elevation={0} sx={stepperStyles.stepperHeaderPaper}>
        <Stepper
          activeStep={activeStep}
          sx={stepperStyles.stepperNavigation(theme)}
        >
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepButton onClick={() => setActiveStep(index)}>
                <StepLabel>{step.label}</StepLabel>
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Scrollable content area */}
      <Box sx={stepperStyles.stepperContentArea}>
        <Box sx={stepperStyles.stepperContentInner}>
          <Paper elevation={1} sx={stepperStyles.stepperContentPaper(theme)}>
            {steps[activeStep].component &&
              React.createElement(steps[activeStep].component, {
                label: steps[activeStep].label,
                description: steps[activeStep].description,
                stepIndex: activeStep,
              })}
          </Paper>
        </Box>
      </Box>

      <StepperFooter stepperContext={stepperContext} />
    </Box>
  );
};
